export type CardInventoryResponse = {
    ve_code: string
    date_distributed: string
    cards_in_packet: number
    amount: number
    name: string
    used_cards: number
    active_cards: number
    unusable_cards: number
}

export interface CardInventoryReduxState {
    cardInventory?: CardInventoryResponse[]
    loading?: boolean
    error?: string
}

export enum CardPaymentStatus {
    SUCCESS = 'success',
    OFFLINE = 'offline',
    FAILED = 'failed',
    PENDING = 'pending'
}

export type CardPaymentPayloadType = {
    transaction_id: string
    date_received: string
    memo: string
    client_code: string
    uuid: string
    amount?: string
    failed_msg?: string
    status?: string
}

export const VeCardInventorySliceEnum = {
    VE_CARD_INVENTORY_SLICE_NAME: 'veCardInventory',
    VE_CARD_INVENTORY_ACTION_PREFIX: 'veCardInventoryAction'
}
